import { graphql } from "~/gql";

export const BEDROCK_GET_ROI_ANALYSIS_QUERY = graphql(/* GraphQL */ `
  query BedrockGetRoiAnalysis($roiData: RoiAnalysisInput!) {
    bedrockRoiAnalyseAndRecommend(roiData: $roiData) {
      analysis
      recommendations
    }
  }
`);
